/**
 * 简洁的雪花 Canvas 效果
 */

class SnowEffect {
    constructor(canvasId, options = {}) {
      this.canvas = document.getElementById(canvasId);
      if (!this.canvas) {
        console.error(`Canvas with id "${canvasId}" not found`);
        return;
      }
  
      this.ctx = this.canvas.getContext('2d');
      this.snowflakes = [];
  
      // 配置选项
      this.config = {
        count: options.count || (window.innerWidth < 768 ? 50 : 150), // 粒子数量
        color: options.color || 'rgba(255, 255, 255, 1)', // 颜色
        minSize: options.minSize || 1, // 最小尺寸
        maxSize: options.maxSize || 2, // 最大尺寸
        speed: options.speed || 5, // 速度
        windSpeed: options.windSpeed || 0.5, // 风速（向右漂移）
        rotationSpeed: options.rotationSpeed || 0.01, // 旋转速度
        width: options.width || null, // 自定义宽度，null 则自动获取
        height: options.height || null, // 自定义高度，null 则自动获取
        debug: options.debug || false, // 是否显示调试信息
      };
  
      this.init();
      this.animate();
  
      // 响应窗口大小变化
      window.addEventListener('resize', () => this.handleResize());
    }
  
    init() {
      // 设置 canvas 尺寸
      this.resizeCanvas();
  
      // 创建雪花
      this.createSnowflakes();
    }
  
    resizeCanvas() {
      // 使用配置的宽高，或者自动获取
      const width = this.config.width || window.innerWidth;
      const height = this.config.height || window.innerHeight;
  
      this.canvas.width = width;
      this.canvas.height = height;
  
      // 调试信息（可选）
      if (this.config.debug) {
        console.log(`Canvas resized: ${width} x ${height}`);
      }
    }
  
    handleResize() {
      // 只有在没有设置固定宽高时才响应窗口大小变化
      if (!this.config.width && !this.config.height) {
        this.resizeCanvas();
        // 根据新尺寸调整粒子数量
        const newCount = window.innerWidth < 768 ? 50 : 150;
        if (newCount !== this.snowflakes.length) {
          this.snowflakes = [];
          this.config.count = newCount;
          this.createSnowflakes();
        }
      }
    }
  
    createSnowflakes() {
      for (let i = 0; i < this.config.count; i++) {
        this.snowflakes.push(this.createSnowflake());
      }
    }
  
    createSnowflake(resetPosition = false) {
      const size =
        Math.random() * (this.config.maxSize - this.config.minSize) +
        this.config.minSize;
      return {
        x: resetPosition
          ? Math.random() * this.canvas.width
          : Math.random() * this.canvas.width,
        y: resetPosition ? -10 : Math.random() * this.canvas.height,
        size: size,
        speed: ((Math.random() * 0.5 + 0.5) * this.config.speed) / 10, // 下落速度
        drift: ((Math.random() * 0.5 + 0.5) * this.config.windSpeed) / 10, // 横向漂移
        rotation: Math.random() * Math.PI * 2, // 当前旋转角度
        rotationSpeed: (Math.random() - 0.5) * this.config.rotationSpeed, // 旋转速度
        opacity: Math.random() * 0.6 + 0.4, // 透明度 0.4-1.0
      };
    }
  
    updateSnowflake(snowflake) {
      // 更新位置
      snowflake.y += snowflake.speed;
      snowflake.x += snowflake.drift;
  
      // 更新旋转
      snowflake.rotation += snowflake.rotationSpeed;
  
      // 添加轻微的左右摆动
      snowflake.x += Math.sin(snowflake.y / 30) * 0.3;
  
      // 如果雪花掉出屏幕，重置到顶部
      if (snowflake.y > this.canvas.height + 10) {
        const newSnowflake = this.createSnowflake(true);
        Object.assign(snowflake, newSnowflake);
      }
  
      // 如果雪花飘出左右边界，重置位置
      if (snowflake.x > this.canvas.width + 10) {
        snowflake.x = -10;
      } else if (snowflake.x < -10) {
        snowflake.x = this.canvas.width + 10;
      }
    }
  
    drawSnowflake(snowflake) {
      this.ctx.save();
  
      // 移动到雪花位置
      this.ctx.translate(snowflake.x, snowflake.y);
  
      // 应用旋转
      this.ctx.rotate(snowflake.rotation);
  
      // 设置样式
      this.ctx.fillStyle = this.config.color.replace(
        '1)',
        snowflake.opacity + ')'
      );
  
      // 绘制圆形雪花
      this.ctx.beginPath();
      this.ctx.arc(0, 0, snowflake.size, 0, Math.PI * 2);
      this.ctx.fill();
  
      this.ctx.restore();
    }
  
    animate() {
      // 清空画布
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  
      // 更新和绘制所有雪花
      this.snowflakes.forEach((snowflake) => {
        this.updateSnowflake(snowflake);
        this.drawSnowflake(snowflake);
      });
  
      // 请求下一帧
      requestAnimationFrame(() => this.animate());
    }
  
    // 公共方法：更新配置
    updateConfig(newConfig) {
      Object.assign(this.config, newConfig);
    }
  
    // 公共方法：销毁实例
    destroy() {
      window.removeEventListener('resize', this.handleResize);
      this.snowflakes = [];
    }
  }
  
  // 自动初始化（如果页面上有 id="One" 的元素）
  // 只有当页面上有 data-auto-init 属性时才自动初始化
  document.addEventListener('DOMContentLoaded', () => {
    const canvas = document.querySelector('#One canvas');
    if (canvas && canvas.hasAttribute('data-auto-init')) {
      // 给 canvas 添加 id 以便初始化
      canvas.id = 'snowCanvas';
      new SnowEffect('snowCanvas');
    }
  });
  